import React from "react";
import ActionButtonList from "./components/ActionButtons/ActionButtonList";
import Svg, {SvgEnum} from "../../ui library/components/svgs/standard/svg";
import {Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

export const Banner = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-evenly w-full min-w-fit">
      <div data-testid="banner-gradient-2" style={{position: 'relative', overflow: 'hidden', background: 'linear-gradient(90.21deg, #6F1F94 0%, #2D1F96 82.21%, #2B9AE7 100%)' }}
           className="w-full min-w-fit h-16 flex flex-row items-center justify-between">
        <div onClick={() => navigate('/dashboard')}>
          <Svg name={SvgEnum.HisLogo} sx={{width: '145px', marginLeft: '70px' }} />
        </div>
        <div class="flex flex-row gap-64">
          <Typography className="text-center text-white capitalize" style={{fontSize: '1.1rem'}}>
            Wellness, Simplified.
          </Typography>
          <Svg name={SvgEnum.Particles1} sx={{
            position: 'absolute',
            right: '-53px',
            top: '-23px',
            width: '82%',
          }}/>
          <Svg name={SvgEnum.Particles2} sx={{
            position: 'absolute',
            right: '112px',
            top: '-101px',
            width: '90%',
          }} />
          {/*<Svg name={SvgEnum.Particles3} sx={{*/}
          {/*  position: 'absolute',*/}
          {/*  right: '304px',*/}
          {/*  top: '-42px',*/}
          {/*  width: '66%',*/}
          {/*}} />*/}
          <ActionButtonList/>
        </div>
      </div>
    </div>
  );
};

